import { Injectable, signal } from '@angular/core';
import { LoadingServiceApi } from '@ireckonu/shared-ui';

@Injectable({ providedIn: 'root' })
export class NoOpLoadingService implements LoadingServiceApi {
  highestActiveContext = signal(0);
  isLoading = signal(false);
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  registerContext(): void {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  removeContext(): void {}
}
